import { useAuth, isAdmin } from '@/lib/auth';
import { ShowcasePlaylistEditor } from '@/components/showcase-playlist-editor';

export function TutorAdminShowcasePlaylistPage() {
  const { profile, user } = useAuth();
  const canEdit = isAdmin(profile, user?.email);

  if (!canEdit || !user) {
    return (
      <div className="mx-auto w-full max-w-3xl px-4 py-6">
        <p className="text-ink-500 text-sm">Réservé aux admins.</p>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-4xl px-4 py-6 sm:py-8">
      <header className="mb-6">
        <h1 className="font-display text-ink-900 text-2xl font-bold">
          Playlist showcase — Landing
        </h1>
        <p className="text-ink-500 mt-1 text-sm">
          Sélectionne des tentatives terminées d&apos;exercices publiés. Elles seront rejouées en
          boucle dans le Hero de la landing publique (cache 1h). C&apos;est aussi la playlist de
          fallback pour le Hero des pages /objectifs/[slug] qui n&apos;ont pas leur propre playlist.
        </p>
      </header>

      <ShowcasePlaylistEditor objectiveTemplateId={null} userId={user.id} />
    </div>
  );
}
